<template>
    <el-select 
        :placeholder="placeholder" 
        v-model="bind" 
        filterable 
        remote 
        reserve-keyword 
        :remote-method="LoadDatas" 
        :loading="loading" 
        :multiple="false" 
        :clearable="clearable"
        @clear="handleClear"
    >
        <el-option 
            v-for="(item,index) in pageData" 
            :key="index" 
            :label="item[label]" 
            :value="item[lakey]" 
        />
    </el-select>
</template>

<script>
export default {
    name: "select-search",
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        api: {type: String, default: ''},
        lakey: {type: String, default: ''},
        label: {type: String, default: ''},
        value: null,
        search: {type: Object, default: () => ({})},
        clearable: {type: Boolean, default: false},
        placeholder: {type: String, default: '请输入关键词'},
        queryField: {type: String, default: 'keyword'}
    },
    data() {
        return {
            bind: '',
            loading: false,
            pageData: [],
            pageInfo: {
                _page: 1,
                _size: 20,
            },
        };
    },
    created() {
        // 初始化时如果有默认值，先加载对应数据
        if (this.value) {
            this.bind = this.value;
            this.loading = true;
            this.search[this.lakey] = this.bind;
            
            this.$get(this.api, Object.assign(this.search, this.pageInfo))
                .then(res => {
                    this.loading = false;
                    delete this.search[this.lakey];
                    this.pageData = res.data;
                    
                    // 修复分页逻辑，不使用可选链
                    const extra = res.data.extra || {};
                    const pageInfo = extra.pageInfo || {};
                    const size = pageInfo.size || this.pageInfo._size;
                    this.pageInfo._page = res.data.length < size ? 0 : (this.pageInfo._page + 1);
                })
                .catch(err => {
                    this.loading = false;
                    delete this.search[this.lakey];
                    this.pageInfo._page = 0;
                });
        } else {
            // 如果没有默认值，也加载一次初始数据
            this.LoadDatas('');
        }
    },
    methods: {
        LoadDatas(query) {
            if (!this.loading) {
                this.loading = true;
                
                // 使用配置的查询字段，默认为'keyword'
                const fieldName = this.queryField || 'keyword';
                
                // 创建新的查询参数，避免污染原始 search 对象
                const queryParams = {
                    ...this.search,
                    ...this.pageInfo
                };
                
                // 如果有查询词，才添加查询字段
                if (query && query.trim()) {
                    queryParams[fieldName] = query.trim();
                }
                
                // 重置分页
                this.pageInfo._page = 1;
                
                this.$get(this.api, queryParams)
                    .then(res => {
                        this.loading = false;
                        this.pageData = res.data || [];
                        
                        // 更新分页信息，不使用可选链
                        const extra = (res.data && res.data.extra) || {};
                        const pageInfo = extra.pageInfo || {};
                        const pageSize = pageInfo.size || this.pageInfo._size;
                        this.pageInfo._page = this.pageData.length < pageSize ? 0 : (this.pageInfo._page + 1);
                    })
                    .catch(err => {
                        this.loading = false;
                        this.pageInfo._page = 0;
                    });
            }
        },
        
        // 处理清除事件
        handleClear() {
            // 清空绑定值
            this.bind = '';
            this.$emit('change', '');
            
            // 清空后重新加载数据
            this.LoadDatas('');
        }
    },
    watch: {
        value(value) {
            if (value !== this.bind) {
                this.bind = value;
            }
        },
        bind(vals) {
            if (vals !== this.value) {
                this.$emit('change', vals);
            }
        }
    }
};
</script>